export default __webpack_public_path__ + "static/media/EditProposalIcon.57885198.svg";